<template>
  <div>
		<main>
			<div class="wrapper">
                <div class="menu_btm_area">
                    <div class="left_box">
                        <p>（{{ computedTodos.length }} 件を表示）</p>
                    </div>
                </div>
            
				<ul class="list_area">
					<li v-for="item in computedTodos" v-bind:key="item.id" v-bind:class="{done:item.state}">
                        <div class="status">
                            <button v-on:click="doChangeState(item)">
                                <p>{{ labels[item.state] }}</p>
                            </button>
                        </div>
						<div class="text_btx">
							<p>{{ item.comment }}</p>
						</div>
						<div class="check">
							<button type="button" v-on:click="doRemove(item)"><i class="fas fa-times-circle"></i></button>
						</div>
					</li>
				</ul>
			</div>
			<div class="send_area">
				<div class="wrapper">
					<form class="content_box" v-on:submit.prevent="doAdd">
						<input type="text" placeholder="ここにタスクを入力" ref="comment">
						<div class="send_btn"><button type="submit"><i class="fas fa-plus-circle"></i></button></div>
					</form>
				</div>
			</div>
		</main>
        
		<footer>
			<div class="btn_area">
				<ul class="content_box" >
					<li v-for="label in options">
                        <input type="radio" v-model="current" v-bind:value="label.value" v-bind:id="label.text">
                        <label v-bind:for="label.text">
                            <i v-bind:class="label.text2"></i>
                            <p>{{ label.text }}</p>
                        </label>
					</li>
				</ul>
			</div>
		</footer>
  </div>
</template>

<script>
    var STORAGE_KEY = 'todos-vuejs-demo'
    var todoStorage = {
        fetch: function () {
            var todos = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
            todos.forEach(function (todo, index) {
            todo.id = index
            })
            todoStorage.uid = todos.length
            return todos
        },
        save: function (todos) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(todos))
        }
    }
    export default {
        name: "todo",
        data() {
            return {
                    todos: [],
                    current: 0,
                    options: [
                        { value: -1, label: 'すべて', text: 'All', text2: 'fas fa-list-ul' },
                        { value: 0, label: '作業中', text: 'List', text2: 'fas fa-tasks' },
                        { value: 1, label: '完了', text: 'Done', text2: 'fas fa-check' }
                    ] 
                }
            },
        computed: {
            computedTodos: function () {
                return this.todos.filter(function (el) {
                    return this.current < 0 ? true : this.current === el.state
                }, this)
            },
            labels() {
                return this.options.reduce(function (a, b) {
                    return Object.assign(a, { [b.value]: b.label })
                }, {})
            }
        },
        watch: {
            todos: {
                handler: function (todos) {
                todoStorage.save(todos)
                },
                deep: true
            }
        },
        created() {
            this.todos = todoStorage.fetch()
        },
        methods: {
            doAdd: function(event, value) {
                var comment = this.$refs.comment
                if (!comment.value.length) {
                    return
                }
                this.todos.push({
                    id: todoStorage.uid++,
                    comment: comment.value,
                    state: 0
                })
                comment.value = ''
            },
            doChangeState: function (item) {
                item.state = !item.state ? 1 : 0
            },
            doRemove: function (item) {
                var index = this.todos.indexOf(item)
                this.todos.splice(index, 1)
            }
        }
    }
</script>